import { createSelector } from 'reselect';

const selectPolicyDomain = (state) => state.policy;

export const selectEndorsementResult = () =>
    createSelector(selectPolicyDomain, (substate) => {
        return substate.endorsementResult;
    });
